import { useState, useContext, useEffect } from "react";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import "./forgotPassword.css";
import usersRequest from "../../request/usersRequest";
import BannerMessageFixed from "../common/bannerMessageFixed/bannerMessageFixed";
import { Link, useNavigate } from "react-router-dom";

const ForgotPassword = () => {
    const { language } = useContext(CombinedContext);

    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [banner, setBanner] = useState({ text: "", type: "info", exiting: false });
    const [emailInvalid, setEmailInvalid] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (!banner.text) return;
        const exitTimer  = setTimeout(() => setBanner((prev) => ({ ...prev, exiting: true })), 2500);
        const removeTimer = setTimeout(() => setBanner({ text: "", type: "info", exiting: false }), 2750);
        return () => { clearTimeout(exitTimer); clearTimeout(removeTimer); };
    }, [banner.text]);

    async function handleSubmit(e) {
        e.preventDefault();

        /* Used to bail silently, which read as a dead button. Flag the field
           and say so instead. */
        if (!email) {
            setEmailInvalid(true);
            setBanner({
                text: language === "es" ? "Escribe tu correo electrónico para continuar." : "Enter your email address to continue.",
                type: "error",
                exiting: false,
            });
            return;
        }

        setEmailInvalid(false);
        try {
            setLoading(true);
            await usersRequest.forgotPassword(email);
            navigate("/confirmforgotpassword");
        } catch (err) {
            console.error(err);
            setBanner({ text: translations[language].forgotPassword.toast.error, type: "error", exiting: false });
        } finally {
            setLoading(false);
        }
    }

    const handleKeyDown = (e) => { if (e.key === "Enter") handleSubmit(e); };

    const t = translations[language].forgotPassword;

    return (
        <div className="sf-auth-page sf-fp-root">
            <div className="sf-auth-shell">
                <div className="sf-auth-card">
                    <div className="sf-auth-head">
                        <h1 className="sf-auth-title">{t.title}</h1>
                        <p className="sf-auth-sub">{t.subtitle}</p>
                    </div>

                    <div className="sf-auth-field">
                        <label className="sf-auth-label" htmlFor="sf-fp-email">{t.email}</label>
                        <input
                            id="sf-fp-email"
                            type="email"
                            className={`sf-auth-input${emailInvalid ? " is-invalid" : ""}`}
                            placeholder={t.email}
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setEmailInvalid(false);
                            }}
                            onKeyDown={handleKeyDown}
                            autoComplete="email"
                            required
                        />
                        <p className="sf-auth-hint">{t.hint}</p>
                    </div>

                    <button className="sf-auth-cta" onClick={handleSubmit} disabled={loading}>
                        {loading && <span className="sf-auth-spinner" aria-hidden="true" />}
                        {loading ? t.sending : t.send}
                    </button>

                    <p className="sf-auth-foot">
                        <Link to="/signin">{t.backToSignIn}</Link>
                    </p>

                    <BannerMessageFixed text={banner.text} type={banner.type} exiting={banner.exiting} />
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;

// import { useState, useContext, useEffect } from "react";
// import { CombinedContext } from "../../context/combinedContext";
// import translations from "../../translations/translations";
// import "./forgotPassword.css";
// import usersRequest from "../../request/usersRequest";
// import BannerMessageFixed from "../common/bannerMessageFixed/bannerMessageFixed";
// import { useNavigate } from "react-router-dom";

// const ForgotPassword = () => {
// 	const { language } = useContext(CombinedContext);

// 	const [email, setEmail] = useState("");
// 	const [loading, setLoading] = useState(false);
// 	const [banner, setBanner] = useState({ text: "", type: "info", exiting: false });

// 	const navigate = useNavigate();

// 	useEffect(() => {
// 		if (!banner.text) return;

// 		const exitTimer = setTimeout(() => setBanner((prev) => ({ ...prev, exiting: true })), 2500);
// 		const removeTimer = setTimeout(() => setBanner({ text: "", type: "info", exiting: false }), 2750);

// 		return () => {
// 			clearTimeout(exitTimer);
// 			clearTimeout(removeTimer);
// 		};
// 	}, [banner.text]);

// 	async function handleSubmit(e) {
// 		e.preventDefault();
// 		if (!email) return;

// 		try {
// 			setLoading(true);
// 			await usersRequest.forgotPassword(email);
// 			navigate("/confirmforgotpassword");
// 		} catch (err) {
// 			console.error(err);
// 			setBanner({ text: translations[language].forgotPassword.toast.error, type: "error", exiting: false });
// 		} finally {
// 			setLoading(false);
// 		}
// 	}

// 	return (
// 		<div className="container">
// 			<div className="card" style={{ maxWidth: 400, margin: "40px auto" }}>
// 				<div className="hd">
// 					<div>{translations[language].forgotPassword.title}</div>
// 				</div>
// 				<div className="bd">
// 					<p className="sf-auth-sub">
// 						{translations[language].forgotPassword.subtitle}
// 					</p>
// 					<div className="row">
// 						<input
// 							type="email"
// 							className="input"
// 							placeholder={translations[language].forgotPassword.email}
// 							value={email}
// 							onChange={(e) => setEmail(e.target.value)}
// 							required
// 						/>
// 						<button
// 							className="btn brand"
// 							style={{ width: "100%" }}
// 							onClick={handleSubmit}
// 							disabled={loading}
// 						>
// 							{loading
// 								? translations[language].forgotPassword.sending
// 								: translations[language].forgotPassword.send}
// 						</button>
// 					</div>

// 					<BannerMessageFixed
// 						text={banner.text}
// 						type={banner.type}
// 						exiting={banner.exiting}
// 					/>
// 				</div>
// 			</div>
// 		</div>
// 	);
// };

// export default ForgotPassword;